
<div v-show="!chatId">
  <button class="ui orange button marunageButton" :class="buttonClass" @click="openDialog" :disabled="disabled">
    <slot></slot>
  </button>
  <div :id="dialogId" class="ui modal">
    <i class="close icon"></i>
    <div class="scrolling content">
        <detailed-marunage-form :action-label="'送信する'" ref="marunageForm" :form-name-prefix="formNamePrefix"></detailed-marunage-form>
    </div>
  </div>
</div>
